import React from "react";
import { Box, Typography } from "@mui/material";
import { UserDocument } from "../../models/UserDocument";
import { displayFormattedDate } from "../../utils/displayDate";
import { DocumentThumbnail } from "./DocumentThumbnail";

interface Props {
  document: UserDocument;
  documentSrc: string;
  onClick: () => void;
}

export const DocumentItem = ({
  document,
  documentSrc,
  onClick,
}: Props): JSX.Element => {
  if (!document.version) {
    console.log("no document version");
    return <></>;
  }

  return (
    <Box
      title={
        document?.notes || document?.version?.title || "click to view file"
      }
      component="button"
      aria-label={document?.version?.title}
      onClick={onClick}
      sx={{
        width: "100%",
        border: "none",
        padding: 0,
        backgroundColor: "transparent",
        textAlign: "left",
        "&:focus-visible, &:focus": {
          outline: "none",
        },
      }}
    >
      <Box
        className="docItemThumbBG"
        sx={{
          backgroundColor: "success.light",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderBottom: "solid 1px",
          borderColor: "grey.400",
          width: "100%",
          height: "180px",
          overflow: "hidden",
        }}
      >
        <DocumentThumbnail document={document} documentSrc={documentSrc} />
      </Box>
      <Box
        sx={{
          paddingLeft: "1rem",
          paddingRight: "1rem",
          paddingTop: "0.5rem",
          paddingBottom: "0.25rem",
        }}
      >
        <Typography
          component={"p"}
          sx={{
            fontWeight: "bold",
            width: "100%",
            height: "70px",
            marginBottom: "5px",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
          className="docItemTitle"
        >
          {document?.version?.title}
        </Typography>
        <Typography variant="body2" color="#999">
          {displayFormattedDate(document?.version?.updatedAt)}
        </Typography>
      </Box>
    </Box>
  );
};

export const DocItemProgress = ({
  percent = 0,
}: {
  percent: number;
}): JSX.Element => {
  return (
    <Box
      sx={{
        backgroundColor: "#D8D8FF",
        height: 8,
      }}
    >
      <Box
        sx={{
          width: `${percent}%`,
          backgroundColor: "#9292FF",
          height: 8,
        }}
      />
    </Box>
  );
};
